import { REDUX_LOCAL_KEY_PREFIX } from '@gymaholic/packages'

/**
 * Checks whether the given instance was changed.
 * @param  {Instance}  instance
 * @returns {boolean}
 */
function hasChangedReduxUtil (instance) {
  if (!instance) {
    return
  }
  return !!Object.keys(instance.changed).filter(key => !key.includes(REDUX_LOCAL_KEY_PREFIX)).length
}

export default hasChangedReduxUtil
